<template lang="pug">
  #app
    .main-wrapper
      router-view
    c-footer
</template>

<script>
import cFooter from '@/components/footer';

export default {
  components: {
    cFooter
  },
  created () {
    this.$store.watch(({ loginStatus }) => {
      if (loginStatus === null) {
        this.$router.replace('login');
        location.reload();
      }
    });
  },
};
</script>

<style lang="less">
* {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  // width: 0px;
  display: none;
}
#app,
body,
html {
  position: relative;
  margin: 0;
}
html {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  min-height: 100%;
}
body {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex: 1 0 auto;
}
div {
  margin:      	0;
  padding:    	0;
}
a {
	color: 			black;
	text-decoration:none;
}
#app {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  flex: 1 0 auto;
  min-height: 352px;
  width: 100%;
}
.main-wrapper {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
}

.display-table {
  display: table;
}
.display-tr {
  display: table-row;
}
.display-td {
  display: table-cell;
}
</style>



// WEBPACK FOOTER //
// App.vue?109b5814